import React, { useContext, useEffect, useState } from "react";
import "./Certificates.css";
import "./ResponsiveCer.css";
import FooterTwo from "../../components/footerTwo/FooterTwo";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { dataContext } from "../../context/DataContextProviderr";
import { filterKey } from "../../helper/function";
import ScrollAnimation from "react-animate-on-scroll";
import LoadingPage from "../../components/loadingPage/LoadingPage";

const Certificates = () => {
  const { isLoadingAwards, awards, allWebParts } = useContext(dataContext);

  const filterCertificates = allWebParts?.filter(
    (x) => x.uniqueName === "certificate"
  );
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [window.location]);
  return (
    <>
      {isLoadingAwards ? (
        <LoadingPage />
      ) : (
        <div className="certificates">
          <div className="mockup"></div>
          <div className="flour-cer">
            <p>
              {filterKey(filterCertificates, "cer-flour-title-part1")?.map(
                (item) => item.Value
              )}{" "}
              <span>
                {filterKey(filterCertificates, "cer-flour-title-part2")?.map(
                  (item) => item.Value
                )}
              </span>
            </p>
            <div className="cer-container">
              <div className="column column1">
                <a
                  href="https://www.zaroil.ir/ZarFlourCertificate/ISO9001-2015-ARDZAR.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={filterKey(filterCertificates, "cer-flour-img1")?.map(
                      (item) => item.Value
                    )}
                    alt="certificate pic"
                  />
                </a>
                <a
                  href="https://www.zaroil.ir/ZarFlourCertificate/ISO10002-2018-ARDZAR.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={filterKey(filterCertificates, "cer-flour-img2")?.map(
                      (item) => item.Value
                    )}
                    alt="certificate pic"
                  />
                </a>
              </div>
              <div className="column column2">
                <a
                  href="https://www.zaroil.ir/ZarFlourCertificate/ISO22000-2018-ARDZAR.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  <img
                    src={filterKey(filterCertificates, "cer-flour-img3")?.map(
                      (item) => item.Value
                    )}
                    alt="certificate pic"
                  />
                </a>
                <a
                  href="https://www.zaroil.ir/ZarFlourCertificate/ISO10004-2012-ARDZAR.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={filterKey(filterCertificates, "cer-flour-img4")?.map(
                      (item) => item.Value
                    )}
                    alt="certificate pic"
                  />
                </a>
              </div>
              <div className="column column3">
                <a
                  href="https://www.zaroil.ir/ZarFlourCertificate/ISO14001-2015-ARDZAR.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={filterKey(filterCertificates, "cer-flour-img5")?.map(
                      (item) => item.Value
                    )}
                    alt="certificate pic"
                  />
                </a>
                <a
                  href="https://www.zaroil.ir/ZarFlourCertificate/ISO45001-2018-ARDZAR.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={filterKey(filterCertificates, "cer-flour-img6")?.map(
                      (item) => item.Value
                    )}
                    alt="certificate pic"
                  />
                </a>
              </div>
            </div>
          </div>

          <div className="semolina-cer">
            <p>
              {filterKey(filterCertificates, "cer-semolina-title-part1")?.map(
                (item) => item.Value
              )}{" "}
              <span>
                {" "}
                {filterKey(filterCertificates, "cer-semolina-title-part2")?.map(
                  (item) => item.Value
                )}
              </span>
            </p>
            <div className="semolinaCer-container">
              <ScrollAnimation
                // animateIn="bounceIn"
                animateIn="slideInUp"
                // animateIn="zoomIn"
                className="cardd"
                delay={200}
              >
<a
                  href="https://www.zaroil.ir/ZarFlourCertificate/ISO9001-2015-SEMOLINA.pdf"
                  target="_blank"
                  rel="noreferrer">
<img
                  src={filterKey(filterCertificates, "cer-semolina-img1")?.map(
                    (item) => item.Value
                  )}
                  alt="semolina-cer"
                />
</a>
              </ScrollAnimation>
              <ScrollAnimation
                // animateIn="bounceIn"
                animateIn="slideInUp"
                // animateIn="zoomIn"
                className="cardd"
                delay={400}
              >
<a                   href="https://www.zaroil.ir/ZarFlourCertificate/ISO14001-2015-SEMOLINA.pdf"
                  target="_blank"
                  rel="noreferrer">
<img
                  src={filterKey(filterCertificates, "cer-semolina-img2")?.map(
                    (item) => item.Value
                  )}
                  alt="semolina-cer"
                />
</a>
              </ScrollAnimation>
              <ScrollAnimation
                // animateIn="bounceIn"
                animateIn="slideInUp"
                // animateIn="zoomIn"
                className="cardd"
                delay={600}
              >
<a                   href="https://www.zaroil.ir/ZarFlourCertificate/ISO22000-2018-SEMOLINA.pdf"
                  target="_blank"
                  rel="noreferrer">
<img
                  src={filterKey(filterCertificates, "cer-semolina-img3")?.map(
                    (item) => item.Value
                  )}
                  alt="semolina-cer"
                />
</a>
              </ScrollAnimation>
              <ScrollAnimation
                // animateIn="bounceIn"
                animateIn="slideInUp"
                // animateIn="zoomIn"
                className="cardd"
                delay={800}
              >
<a                   href="https://www.zaroil.ir/ZarFlourCertificate/ISO45001-2018-SEMOLINA.pdf"
                  target="_blank"
                  rel="noreferrer">
<img
                  src={filterKey(filterCertificates, "cer-semolina-img4")?.map(
                    (item) => item.Value
                  )}
                  alt="semolina-cer"
                />
</a>
              </ScrollAnimation>
            </div>
          </div>

          <div className="awards">
            <Swiper
              slidesPerView={3}
              spaceBetween={30}
              navigation={true}
              modules={[Navigation]}
              centeredSlides={true}
              className="mySwiper"
              // initialSlide={1}
              loop={true}
            >
              {awards &&
                awards?.map((item, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={`${window.Configs["ui-base-url"]}/Api/V1/ui/Content/Image?entityName=3&imageName=${item.image}`}
                      alt="awards pic"
                    />
                    <p>{item.title}</p>
                  </SwiperSlide>
                ))}
            </Swiper>
          </div>

          <FooterTwo />
        </div>
      )}
    </>
  );
};

export default Certificates;
